import { getUploadServiceApi } from '@/utils'

type PresignRequest = {
  key: string
  contentType: string
  bucket?: string
  expiresIn?: number
}

type PresignResponse = {
  uploadUrl: string
  publicUrl: string
  expiresAt: string
}

export async function getPresignedUploadUrl(
  req: PresignRequest,
): Promise<PresignResponse> {
  const base = getUploadServiceApi().replace(/\/$/, '')
  const res = await fetch(`${base}/upload/presigned-url`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      key: req.key,
      contentType: req.contentType,
      bucket: req.bucket,
      expiresIn: req.expiresIn ?? 900,
    }),
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`Failed to get presigned URL (${res.status}): ${text}`)
  }
  return (await res.json()) as PresignResponse
}

export async function putFileToS3(
  uploadUrl: string,
  file: File | Blob,
  contentType: string,
) {
  const putRes = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  })
  if (!putRes.ok) {
    const text = await putRes.text().catch(() => '')
    throw new Error(`Failed to upload to S3 (${putRes.status}): ${text}`)
  }
}

export function inferExtension(contentType: string): string {
  const map: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/svg+xml': 'svg',
  }
  return map[contentType] || 'bin'
}
